import React, { useState } from 'react';
import {
    EuiPopover,
    EuiButtonIcon,
    EuiFlexGroup,
    EuiFlexItem,
    EuiText,
    EuiButton,
    EuiSpacer,
    EuiToolTip,
    EuiPanel,
    EuiIcon,
} from '@elastic/eui';
import { NOTIFICATION_VARIABLES } from './variableHelper';

// Custom icon component - curly braces to represent variables
const AddVariableIcon = ({ size = 18 }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <path d="M8 4c0 0-2 0-2 2v4c0 2-2 2-2 2s2 0 2 2v4c0 2 2 2 2 2" />
        <path d="M16 20c0 0 2 0 2-2v-4c0-2 2-2 2-2s-2 0-2-2V6c0-2-2-2-2-2" />
        <path d="M12 8v8" />
    </svg>
);

export const VariableSelector = ({ onSelectVariable, buttonLabel = 'Variables' }) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const handleVariableSelect = (variable) => {
        onSelectVariable(variable.key);
        setIsPopoverOpen(false);
    };

    const button = (
        <EuiToolTip content="Insert variable">
            <EuiButtonIcon
                iconType={AddVariableIcon}
                aria-label="Insert variable"
                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                size="m"
                display="fill"
                style={{
                    backgroundColor: '#f3f4f6',
                    borderColor: '#d3dae6',
                    color: '#1a1a1a'
                }}
            />
        </EuiToolTip>
    );

    return (
        <EuiPopover
            button={button}
            isOpen={isPopoverOpen}
            closePopover={() => setIsPopoverOpen(false)}
            panelPaddingSize="m"
            anchorPosition="downLeft"
        >
            <div style={{ width: 300 }}>
                <EuiText size="s">
                    <h4>Available Variables</h4>
                </EuiText>
                <EuiSpacer size="s" />
                {NOTIFICATION_VARIABLES.map((variable, index) => (
                    <EuiPanel
                        key={variable.key}
                        paddingSize="s"
                        style={{ marginBottom: index < NOTIFICATION_VARIABLES.length - 1 ? '8px' : 0 }}
                        onClick={() => handleVariableSelect(variable)}
                        className="euiPanel--clickable"
                    >
                        <EuiFlexGroup alignItems="center" gutterSize="s">
                            <EuiFlexItem grow={false}>
                                <EuiButton
                                    size="s"
                                    fill
                                    minWidth={0}
                                    style={{ fontSize: '12px' }}
                                >
                                    {variable.label}
                                </EuiButton>
                            </EuiFlexItem>
                            <EuiFlexItem>
                                <EuiText size="xs" color="subdued">
                                    {variable.description}
                                </EuiText>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiSpacer size="xs" />
                        <EuiFlexGroup gutterSize="xs" alignItems="center">
                            <EuiFlexItem grow={false}>
                                <EuiText size="xs">
                                    <strong>Variable:</strong>
                                </EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem>
                                <EuiText size="xs" color="accent">
                                    <code>{variable.key}</code>
                                </EuiText>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiFlexGroup gutterSize="xs" alignItems="center">
                            <EuiFlexItem grow={false}>
                                <EuiText size="xs">
                                    <strong>Fallback:</strong>
                                </EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem>
                                <EuiText size="xs" color="subdued">
                                    "{variable.fallback}"
                                </EuiText>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                        <EuiFlexGroup gutterSize="xs" alignItems="center">
                            <EuiFlexItem grow={false}>
                                <EuiText size="xs">
                                    <strong>Note:</strong>
                                </EuiText>
                            </EuiFlexItem>
                            <EuiFlexItem>
                                <EuiText size="xs" color="subdued">
                                    "{variable.note}"
                                </EuiText>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiPanel>
                ))}
                <EuiSpacer size="s" />
                <EuiText size="xs" color="subdued">
                    <em>Click on a variable to insert it at the current cursor position</em>
                </EuiText>
            </div>
        </EuiPopover>
    );
};